const audioTracks = [
  {
    url: './assets/sounds/Max_Brhon-Cyberpunk_cut.mp3',
    author: 'Max Brhon',
    title: 'Cyberpunk',
  },
  {
    url: './assets/sounds/Extra_Terra-Cyberpunk.mp3',
    author: 'Extra Terra',
    title: 'Cyberpunk',
  },
  {
    url: './assets/sounds/Hyper-Spoiler.mp3',
    author: 'Hyper',
    title: 'Spoiler',
  },
  {
    url: './assets/sounds/Reggio-Cyberpunk.mp3',
    author: 'Reggio',
    title: 'Cyberpunk',
  },
];

export default audioTracks;
